module.exports = __webpack_public_path__ + "static/img/3.759ecb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/3.png
// module id = H9DG
// module chunks = 0